import Seo from "../components/Seo";

export default function Terms() {
  return (
    <div data-testid="page-terms" className="bg-white">
      <Seo title="Terms & Conditions" description="Terms and conditions for use of the The Mogul Group Advisors website." path="/terms" />
      <div className="container-wide py-20 max-w-3xl">
        <div className="overline mb-4">Legal</div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight leading-tight">Terms & Conditions</h1>
        <div className="mt-8 space-y-6 text-[#4B5563] leading-relaxed text-[15px]">
          <p>By using this website, you agree to these terms. This website is provided for informational purposes and to facilitate consultation requests. Nothing on this website constitutes a binding contract, guarantee of results, or a specific outcome.</p>
          <h2 className="font-serif text-xl text-[#0A0A0A] pt-4">Services</h2>
          <p>All engagements are governed by a separate signed agreement between The Mogul Group Advisors and the client, which will describe the specific scope, deliverables, and terms of that engagement.</p>
          <h2 className="font-serif text-xl text-[#0A0A0A] pt-4">No guarantees</h2>
          <p>We do not guarantee business growth, advertising results, government-contract awards, funding, revenue, approvals, or procurement outcomes.</p>
          <h2 className="font-serif text-xl text-[#0A0A0A] pt-4">Intellectual property</h2>
          <p>All content on this site is the property of The Mogul Group, LLC or its licensors and may not be reproduced without permission.</p>
          <p className="text-xs text-[#6B7280] pt-4">These terms are provided for informational purposes and can be updated by the administrator.</p>
        </div>
      </div>
    </div>
  );
}
